<template>
  <v-container fluid pa-0 class="paymentMethod">
    <v-flex xs12 style="font-size: 36px; font-weight: 700" class="primary--text">
      Payment Method
    </v-flex>
    <v-flex v-if="loading" class="paymentLoadingState"><v-progress-circular :size="70" :width="7" color="accent" indeterminate></v-progress-circular></v-flex>
    <v-flex :class="loading ? 'blurClass' : ''" style="margin-top: 60px; min-height: 100px">
      <v-flex>
        <v-card v-for="(card, key) in cards" :key="key" color="secondary" class="elevation-0" style="width:600px;height: 100px; margin-bottom: 50px; border-radius: 10px" v-if="cards !== null">
          <v-card-text style="display: flex; align- items: center; height: 100%">
            <v-layout row>
              <v-icon size="26" color="primary">fab fa-cc-{{cardBrand(card)}}</v-icon><v-flex class="primary--text" style="font-size: 18px; flex: none; display: flex; align-items: center; margin-left: 30px"><span style="text-transform: capitalize; padding-right: 4px">{{cardBrand(card)}}</span> ending in {{ card.last4 }}</v-flex>
              <v-spacer></v-spacer>
              <div style="display: flex; flex-direction: column; justify-content: center;">
                <div v-if="defaultId !== card.id" class='pay-with-stripe center cardManagementBtn' :loading='deletingCard === key' :disabled='deletingCard === key || loading' @click='deleteCard(card.id, key)'>Remove Card</div>
                <div v-if="defaultId !== card.id" class='pay-with-stripe center cardManagementBtn' :loading='setCardAsDefault === key' :disabled='setCardAsDefault === key || loading' @click='setDefaultCard(card.id, key)'>Set Default</div>
              </div>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-flex @click="newCard = true; updating = true" style="display: flex; align-items: center; cursor: pointer; font-size: 18px;" mt-3 class="primary--text">
          <img src="@/assets/add.png" style="width: 22px; height: 22px; margin-right: 5px" />Add another card
        </v-flex>
        <v-card v-if="newCard" color="secondary" class="elevation-0" style="width:600px;height: 100px;border-radius: 10px;margin-top: 50px;">
          <v-card-text style="display: flex; align- items: center; height: 100%">
            <v-layout row style="display: flex; align-items: center">
              <Card style="min-width: 450px; display: flex; align-items: center" v-if="updating" :stripe='stripeKey' :options='stripeOptions' @change='complete = $event.complete'></Card>
              <v-spacer></v-spacer>
              <div v-if="updating" class='pay-with-stripe cardManagementBtn' @click='pay'>Add</div>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pa-3">
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-flex>
  </v-container>
</template>

<style>
.cardManagementBtn{
  font-size: 18px;
  text-align: right;
  cursor: pointer;
  color: #011E41 !important;
}
.blurClass{
  -webkit-filter: blur(5px);
  filter: blur(5px);
}
.paymentLoadingState, .noDataState, .errorState{
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  position: absolute;
  top: 0;
  width: 600px;
  bottom: 0;
  align-items: center;
  justify-content: center;
  z-index: 9
}
.noDataState {
  box-shadow: none !important;
}
.paymentMethod .StripeElement {
  height: 40px;
  padding: 10px 12px;
  border-radius: 10px;
  width: 100%;
  border: 1px solid #011E41;
}

.paymentMethod .StripeElement--focus {
  box-shadow: 0 1px 3px 0 #011E41;
}

.paymentMethod .StripeElement--invalid {
  border-color: #011E41;
}

.paymentMethod .StripeElement--webkit-autofill {
  background-color: #011E41 !important;
}
</style>

<script>
import config from '@/helpers/config'
import { Card, createToken } from 'vue-stripe-elements-plus'
import { mapMutations, mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      customerId: null,
      defaultId: null,
      cards: null,
      deletingCard: null,
      setCardAsDefault: null,
      updating: false,
      loading: false,
      complete: false,
      stripeOptions: config.stripeOptions,
      stripeKey: config.stripeKey,
      warning: false,
      success: false,
      newCard: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      getUserOrganization: 'getUserOrganization'
    })
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    cardExpiry: function (card) {
      return (card.expMonth < 10 ? '0' : '') + card.expMonth + '/' + (card.expYear % 2000 < 10 ? '0' : '') + card.expYear % 2000
    },
    cardBrand: function (card) {
      if (card.brand === 'American Express') {
        return 'amex'
      } else {
        return card.brand.replace(/\s+/g, '-').toLowerCase()
      }
    },
    getData () {
      this.loading = true
      let organizationUuid = this.currentUser.organizations.find(x => { return x.id === this.currentUser.defaultOrganizationId }).uuid
      axios.all([this.$store.dispatch('stripe/retrieveCustomer', {organizationUuid: organizationUuid})]).then(axios.spread((customerResponse) => {
        if (customerResponse.data.payload !== undefined && customerResponse.data.payload.id !== undefined) {
          this.customerId = customerResponse.data.payload.id
          if (customerResponse.data.payload.sources !== null && customerResponse.data.payload.sources.totalCount !== 0) {
            this.cards = customerResponse.data.payload.sources.data
            this.deletingCard = null
            this.defaultId = customerResponse.data.payload.defaultSource ? customerResponse.data.payload.defaultSource.id : null
            this.warning = false
            this.success = true
            this.loading = false
          } else {
            this.loading = false
            this.cards = null
            this.warning = true
            this.success = false
          }
        } else {
          this.loading = false
          this.cards = null
          this.warning = true
          this.success = false
        }
      })).catch((err) => {
        this.loading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    pay () {
      this.loading = true
      createToken().then(data => this.addCard(data.token.id))
    },
    async addCard (source) {
      try {
        let organizationUuid = this.getUserOrganization.uuid
        let description = this.currentUser.organizations.find(x => { return x.id === this.currentUser.defaultOrganizationId }).name
        let email = this.currentUser.email
        let customerResponse = await this.$store.dispatch('stripe/addCard', {organizationUuid: organizationUuid, description: description, email: email, source: source})
        if (customerResponse.data.status === 'SUCCESS') {
          if (customerResponse.data.payload !== undefined && customerResponse.data.payload.sources !== null) {
            this.warning = false
            this.success = true
            this.newCard = false
            this.updating = false
            this.complete = false
            this.getData()
          } else {
            this.warning = true
            this.success = false
          }
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        this.notify({message: 'Failed to update billing information.', show: true})
        console.log(err)
      }
    },
    async deleteCard (cardId, key) {
      try {
        this.deletingCard = key
        let customerResponse = await this.$store.dispatch('stripe/deleteCard', {customerId: this.customerId, cardId: cardId})
        if (customerResponse.data.status === 'SUCCESS') {
          if (customerResponse.data.payload !== undefined && customerResponse.data.payload.sources !== null) {
            // this.notify({message: 'Card removed.', show: true})
            this.getData()
          } else {
            this.deletingCard = null
            this.loading = false
            this.notify({message: 'Failed to remove card.', show: true})
          }
        } else {
          this.deletingCard = null
          this.loading = false
          this.notify({message: 'Failed to remove card.', show: true})
        }
        this.loading = false
      } catch (err) {
        this.deletingCard = null
        this.loading = false
        this.notify({message: 'Failed to remove card.', show: true})
        console.log(err)
      }
    },
    async setDefaultCard (cardId, key) {
      this.loading = true
      try {
        this.setCardAsDefault = key
        let customerResponse = await this.$store.dispatch('stripe/setDefaultCard', {customerId: this.customerId, cardId: cardId})
        if (customerResponse.data.status === 'SUCCESS') {
          if (customerResponse.data.payload !== undefined && customerResponse.data.payload.sources !== null) {
            // this.notify({message: 'Default card set.', show: true})
            this.setCardAsDefault = false
            this.getData()
          }
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        this.notify({message: 'Failed to set default card.', show: true})
        console.log(err)
      }
    }
  },
  mounted: function () {
    this.updating = false
    this.newCard = false
    this.getData()
  },
  components: {
    Card
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organization/OrganizationPaymentMethods.vue